import services from "@/http";
import * as types from "./mutation-types";

export const ActionGetAll = async ({ dispatch }, payload) => {
  let data = await dispatch("ActionFind", payload);
  dispatch("ActionSetUsers", data.data);
  dispatch("ActionSetPagination", data.meta);
};

export const ActionFind = async (store, search) => {
  var users = {
    data: [],
    meta: {},
  };

  await services.users.get_all(search).then((res) => {
    users = res.data;
  });
  return users;
};

export const ActionShow = async ({ dispatch }, id) => {
  await services.users.show({ id: id }).then((res) => {
    dispatch("ActionSetUser", res.data.user);
  });
};

export const ActionSave = async ({ dispatch }, payload) => {
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }
};

export const ActionStore = async ({ commit }, payload) => {
  await services.users.store(payload).then((res) => {
    commit(types.SET_USER, res.data.user);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.users.update({ id: payload.id }, payload).then((res) => {
    commit(types.SET_USER, res.data.user);
  });
};

export const ActionDelete = async ({ commit }, id) => {
  await services.users.delete({ id: id }).then(() => {
    commit(types.SET_USER, null);
  });
};

export const ActionSetUsers = ({ commit }, payload) => {
  commit(types.SET_USERS, payload);
};

export const ActionSetUser = ({ commit }, payload) => {
  commit(types.SET_USER, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionNewUser = ({ commit }) => {
  let user = {
    nome: "",
    descricao: "",
    cliente_id: "",
    cliente: [],
    roles: [],
  };
  commit(types.SET_USER, user);
};

export const ActionSaveProfile = async ({ commit }, payload) => {
  /*
  const change_form_data = (formData, values, index = null) => {
    for (var key in values) {
      let value = values[key];

      if (index) {
        key = index + "[" + key + "]";
      }

      if (value instanceof File) {
        formData.append(key, value);
      } else if (typeof value === "object") {
        change_form_data(formData, value, key);
      } else {
        formData.append(key, value);
      }
    }
  };
  const formData = new FormData();
  change_form_data(formData, payload);
  */

  let user = null;
  await services.users.profileStore(payload).then((res) => {
    user = res.data.user;
  });
  return user;
};
